import { render, staticRenderFns } from "./Plural.vue?vue&type=template&id=17757f29&scoped=true"
import script from "./Plural.vue?vue&type=script&lang=js"
export * from "./Plural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17757f29",
  null
  
)

export default component.exports